import { useSelector } from '_common/hooks';
import EditorManager from 'Editor/services/EditorManager';
import ToolbarDropdown from 'Editor/components/ToolbarDropdown/ToolbarDropdown';

const SIZES = [
  { label: '8', value: '8' },
  { label: '9', value: '9' },
  { label: '10', value: '10' },
  { label: '11', value: '11' },
  { label: '12', value: '12' },
  { label: '14', value: '14' },
  { label: '18', value: '18' },
  { label: '24', value: '24' },
  { label: '30', value: '30' },
  { label: '36', value: '36' },
  { label: '48', value: '48' },
  { label: '60', value: '60' },
  { label: '72', value: '72' },
  { label: '96', value: '96' },
];

type FontSizeProps = { isReadOnlyMode?: boolean };

const FontSize = ({ isReadOnlyMode }: FontSizeProps) => {
  const fontSize = useSelector((state) => state.editor.toolbar.fontSize ?? '');

  return (
    <ToolbarDropdown
      disabled={isReadOnlyMode}
      isCreatable={true}
      options={SIZES}
      onChange={(option) => {
        setTimeout(() => {
          //@ts-expect-error
          EditorManager.getInstance().toggleSelectionStyle('fontSize', option.value);
        }, 0);
      }}
      value={{ label: `${fontSize}`, value: `${fontSize}` }}
      width="15"
      createOptionPosition="first"
      formatCreateLabel={(label: string) => label}
      onOptionCreate={(label: string) => label}
      isValidNewOption={(option: string) => {
        if (
          option.match(/^\d+(\.\d{0,2})?$/g) &&
          !SIZES.map((size) => size.value).includes(option)
        ) {
          return true;
        }
        return false;
      }}
      styles={{
        menuList: (provided) => ({
          ...provided,
          maxHeight: '59rem',
        }),
      }}
      testId="font-size"
    />
  );
};

export default FontSize;
